var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      staticClass: "svgbtn",
      style: _vm.btnStyle,
      attrs: { role: "button", tabindex: "0" },
      on: {
        click: _vm.onclick,
        keypress: function($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          ) {
            return null
          }
          $event.preventDefault()
          return _vm.onclick($event)
        }
      }
    },
    [
      _c("use", { attrs: { "xlink:href": "#" + _vm.sprite } }),
      _vm.title
        ? _c("title", { attrs: { role: "presentation" } }, [
            _vm._v(_vm._s(_vm.title))
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }